__turbopack_context__.v({
  "ManualPagination": "_6EnjW_ManualPagination",
  "ManualPagination__Icon": "_6EnjW_ManualPagination__Icon",
  "ManualPagination__Icon--Prev": "_6EnjW_ManualPagination__Icon--Prev",
  "ManualPagination__Label": "_6EnjW_ManualPagination__Label",
  "ManualPagination__Link": "_6EnjW_ManualPagination__Link",
  "ManualPagination__Link--Next": "_6EnjW_ManualPagination__Link--Next",
  "ManualPagination__Text": "_6EnjW_ManualPagination__Text",
  "ManualPagination__Title": "_6EnjW_ManualPagination__Title",
});
